import Vue from 'vue'
import App from './App'

import router from './router/router';

import store from './store';
// import { loadStyle } from './util/util'
import * as urls from '@/config/env';

// 引入echarts
import echarts from 'echarts'
//引入公共样式
import './components/css/common.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.$echarts = echarts
Vue.component('echarts', echarts);


Vue.use(ElementUI)

Vue.config.productionTip = false;

Vue.use(router)

// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key];
})

// 动态加载阿里云字体库
// iconfontVersion.forEach(ele => {
//   loadStyle(iconfontUrl.replace('$key', ele));
// })

Vue.config.productionTip = false

//页面切换 回到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js